export const version = "contracts/5.6.1";
//# sourceMappingURL=_version.js.map